import React from "react";
import ButtonBase from "../_base/ButtonBase";
import styles from "./index.module.css";

const SecondaryButton = React.forwardRef(function SecondaryButton(props, ref) {
  return (
    <ButtonBase {...props} ref={ref} styles={styles} spinnerColor="#ffffff" />
  );
});

export default SecondaryButton;
